import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowId.config.matrixDefinitions.qbooks', {
    qbooksApprovalMatrixAmountHeaderText: 'Total amount',
});
